import { ReactNode } from 'react';

/**
 * Standard page title row: title + optional description on the left, actions
 * on the right. Wraps under the title on narrow screens.
 */
export default function PageHeader({
  title,
  description,
  actions,
  meta,
}: {
  title: ReactNode;
  description?: ReactNode;
  /** Buttons / controls, right-aligned. */
  actions?: ReactNode;
  /** Small line under the description (counts, last-updated…). */
  meta?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3">
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">{title}</h1>
        {description && <p className="mt-1 text-sm text-slate-500">{description}</p>}
        {meta && <div className="mt-2 text-xs text-slate-500">{meta}</div>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
